export default __webpack_public_path__ + "static/media/bg4.ff62ac0b.jpg";